// extracted by mini-css-extract-plugin
module.exports = {"warningContainer":"warningBanner_warningContainer__bTUJA","warning":"warningBanner_warning__TRUHH","warningIcon":"warningBanner_warningIcon__281q4"};